import { deleteService } from "../../api/serviceService";

export const useDeleteService = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteService(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete service:", error);
            throw error;
        }
    };

    return { remove };
};